import api from '@/api';

const { $student } = api;

export const { $examenesAlumno } = $student;